import useSelector from '@hooks/useSelector'

export type Entity = {
  id: number | null,
  [key: string]: any,
}

export type Options = {
  customUseSelectorFn?: () => void,
}

export type UseLatestEntityPayload<T> = {
  entity: T,
  isLatest: T | undefined | {},
}

function useLatestEntity<T>(initEntity: T, entityKey: string, options?: Options): UseLatestEntityPayload<T> {
  const { customUseSelectorFn } = options || {}

  // @ts-expect-error
  const { id } = initEntity

  const useSelectorFn = customUseSelectorFn || useSelector
  const entities = useSelectorFn(reduxState => (reduxState as any).entities[entityKey])

  // inStore looks like it could be wrong. The name and usage suggests this should be a boolean, but it is not.
  // Even though this value is returned, nothing external uses it. Leaving as is for now since no problems
  // have been found.
  const inStore = id && entities[id]
  const entity = inStore ? entities[id] : initEntity

  return {
    entity,
    isLatest: inStore,
  }
}

export default useLatestEntity
